import React, { Component } from "react";

class Brand extends Component{
    render(){
        const {branstyle } = this.props;
        return(
            <React.Fragment>
                <ul className={`brand-list ${branstyle}`}>
                    <li >
                        <img src="/assets/images/brand/tamaulipas2.png" alt="Marca de Fenamix"/>
                    </li>
                    <li>
                        <img src="/assets/images/brand/image.png"  alt="Zerobolas"/>
                    </li>
                    <li>
                        <img src="/assets/images/brand/fenamix.png"  alt="Marca del Gobierno de Tamaulipas"/>
                    </li>
                    <li>
                        <img src="/assets/images/brand/fanatoon.png" alt="Logo Images"/>
                    </li>
                </ul>
            </React.Fragment>
        )
    }
}
export default Brand;